import {SIGN_TYPE_EVENT} from './sign-type';

class SwitchSigninSignupInModal {
    constructor(root, params) {
        this.switchLink = root;
        this.type = params.type;
        this.dispatchSwitchEventToConnectPopup = this.dispatchSwitchEventToConnectPopup.bind(this);
        this.initListeners();
    }

    dispatchSwitchEventToConnectPopup() {
        Hop.events.trigger(SIGN_TYPE_EVENT.CHANGE_TYPE, this.type);
    }

    initListeners() {
        this.switchLink.addEventListener('click', this.dispatchSwitchEventToConnectPopup);
    }

    removeListeners() {
        this.switchLink.removeEventListener('click', this.dispatchSwitchEventToConnectPopup);
    }

    destroy() {
        this.removeListeners();
    }
}

Hop.defineModule('switch-signin-signup-in-modal', (root, params) => {
    const switchSigninSignupInModal = new SwitchSigninSignupInModal(root, params);

    return function destroy() {
        switchSigninSignupInModal.destroy();
    };
});
